import type { ChatbotMetric } from '../../../types/chatbot-message.types';

import { MetricRow } from './metric-row';

interface LabeledCardProps {
  title: string;
  body?: string | undefined;
  metrics?: ChatbotMetric[] | undefined;
}

/**
 * Card with a title + optional body + optional metric rows (no status badge).
 * Used for analytical sections like the chatbot's "Overall DID lift" /
 * "Category Standouts" callouts. Visually parallel to StatusCard but without
 * the colored eyebrow badge — semantically distinct from a status update.
 */
export function LabeledCard({ title, body, metrics }: LabeledCardProps) {
  return (
    <div className="bg-muted/40 space-y-2 rounded-xl p-3">
      <p className="text-sm font-semibold">{title}</p>
      {body ? <p className="text-muted-foreground text-xs leading-5">{body}</p> : null}
      {metrics && metrics.length > 0 ? (
        <div className="space-y-1.5 pt-1">
          {metrics.map((metric, idx) => (
            <MetricRow key={`${metric.label}-${String(idx)}`} {...metric} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
